import ActivateDefaultResponse from 'actions/composition/activate_default_response';
import { getActiveConversationId } from 'actions/conversation/lib/conversation_helpers';
import SelectedKbItem from 'models/selected_kb_item';
import Snippet, { SnippetChannels, SnippetContent, SnippetChannel } from 'models/answers/snippet';
import qconsole from 'scripts/lib/qconsole';

export default class UseTeamAssistResponse {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, messageId }) {
    const customerStores = this.context.stores.customers.storesFor(customerId);
    const message = customerStores.teamAssists.find(messageId);
    if (!message || !message.content) {
      qconsole.log(`UseTeamAssistResponse: message [${messageId}] not found or empty`);
      return;
    }

    if (message.role === 'ai_response' && message.type === 'suggested_response') {
      this.context.analytics.track('Team Assist Suggested Response Used', {
        customerId,
        sessionId: message.sessionId,
        messageId,
      });
    }

    const currentLocation = this.context.stores.currentLocation.get();
    let compositionId = currentLocation.currentCompositionId;

    if (!compositionId) {
      const conversationId = getActiveConversationId(customerStores.conversations);
      if (conversationId) {
        this.context.executeAction(ActivateDefaultResponse, { conversationId });
      }
    }

    const snippetContent = SnippetContent.create({ bodyHtml: message.content });
    const snippetChannels = SnippetChannels.create({
      anyChannel: snippetContent,
      language: 'en-us',
    });
    const fakeSnippet = Snippet.create({
      name: 'Team Assist Response',
      contents: [snippetChannels],
    });

    this.context.stores.selectedKbItem.set(
      SelectedKbItem.create({
        item: fakeSnippet,
        channelType: SnippetChannel.ANY_CHANNEL,
        language: 'en-us',
      })
    );
  }
}
